import { ca } from '@cian/analytics';

export function trackRealtyValuationInView() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardBuilder',
    action: 'show_dynamic',
    useLastProducts: true,
  });
}

export function trackRealtyValuationClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardBuilder',
    action: 'click_dynamic',
    useLastProducts: true,
  });
}
